/**
 * Hyros Event Listeners
 *
 * Uses the unified event system (pmw:pixel:*) with firing decisions.
 *
 * Hyros is an attribution pixel. Attribution pixels follow the statistics
 * consent category.
 */

(function (pmw, undefined) {

	/**
	 * Load pixel on consent
	 */
	pmw.bus.on("pmw:load-pixels", function () {
		if (
			pmwDataLayer?.pixels?.hyros?.product_hash &&
			!pmwDataLayer?.pixels?.hyros?.loaded &&
			pmw.consent.canPixelBeFired("statistics", "Hyros")
		) {
			pmw.loadHyrosPixel()
		}
	})

	/**
	 * Add to Cart event
	 */
	pmw.bus.on("pmw:pixel:add-to-cart", (payload) => {
		if (!pmwDataLayer?.pixels?.hyros?.loaded) return
		if (!pmw.shouldFireBrowserPixel(payload, "hyros")) return

		try {
			const hyrosData = payload.pixels?.hyros
			if (!hyrosData) return

			pmw.hyrosAddLeadTag(hyrosData)
		} catch (e) {
			console.error(e)
		}
	})

	/**
	 * Begin Checkout event
	 */
	pmw.bus.on("pmw:pixel:begin-checkout", (payload) => {
		if (!pmwDataLayer?.pixels?.hyros?.loaded) return
		if (!pmw.shouldFireBrowserPixel(payload, "hyros")) return

		try {
			const hyrosData = payload.pixels?.hyros
			if (!hyrosData) return

			pmw.hyrosAddLeadTag(hyrosData)
		} catch (e) {
			console.error(e)
		}
	})

	/**
	 * Purchase / Order Received event
	 *
	 * The tag marks the journey milestone only. The sale itself reaches Hyros
	 * through its WooCommerce integration, which pulls orders from the
	 * WooCommerce REST API.
	 */
	pmw.bus.on("pmw:pixel:purchase", (payload) => {
		if (!pmwDataLayer?.pixels?.hyros?.loaded) return
		if (!pmw.shouldFireBrowserPixel(payload, "hyros")) return

		try {
			const hyrosData = payload.pixels?.hyros
			if (!hyrosData) return

			pmw.hyrosAddLeadTag(hyrosData)
		} catch (e) {
			console.error(e)
		}
	})

}(window.pmw = window.pmw || {}));
